import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div
        data-testid="protected-loading"
        className="min-h-screen flex items-center justify-center"
      >
        <div className="flex items-center gap-2 text-zinc-500 text-sm">
          <span className="h-2 w-2 rounded-full bg-amber-500 pulse-dot" />
          Loading…
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
